module.exports = __webpack_public_path__ + "static/media/drone-view-of-magnificent-rocky-terrain-in-mongolia-4326283.9b7d1f1b.jpg";